export const SITE_CONFIG = {
    CONTACT_EMAIL: "neurorehabilitation@arditi.pt",
    MATOMO_URL: "https://analytics.arditi.pt/",
}